import React, { useEffect, useState } from "react"
import createDOMPurify from "dompurify"
// import { gtag } from "ga-gtag"
import { Link, navigate } from "gatsby"
import { Dialog } from "primereact/dialog"
import { Button } from "primereact/button"

import "./menu-card.css"

function MenuCard({ cardData, index }) {
  const [purify, setPurify] = useState()
  const [readMore, setReadMore] = useState(false)

  useEffect(() => {
    if (
      typeof window !== "undefined" &&
      typeof window.navigator !== "undefined"
    ) {
      setPurify(createDOMPurify(window))
    }
  }, [])

  const handleSpanTag = text => {
    if (text !== null) {
      let newtext = text?.replaceAll("[", "<p>").replaceAll("]", "</p>")
      return newtext
    } else {
      return
    }
  }

  // const onContactUsBtnClick = (ctaTitle) => {
  //   document.getElementById("heartElement")?.click()
  //   gtag("event", ctaTitle, {
  //     event_category: "contact-us",
  //     event_label: "Contact Form",
  //   })
  // }

  const handleClick = value => {
    if (cardData?.slug) {
      if (cardData?.cardType)
        navigate("/" + cardData.cardType + "/" + cardData.slug.current)
      else navigate("/" + cardData.slug.current)
    } else {
      const fade = document.querySelector(".background-fade")
      setReadMore(value)
      if (value) {
        fade.style.display = "block"
        document.documentElement.style.overflow = "hidden"
        // window.fullpage_api?.setAllowScrolling(false)
      } else {
        fade.style.display = "none"
        // window.fullpage_api?.setAllowScrolling(true)
        document.documentElement.style.overflow = "auto"
      }
    }
  }

  return (
    <div className="menu-card">
      {/* <div className="index-container">
        <p>{index + 1}</p>
      </div> */}
      <div
        className={`menu-card-details ${
          cardData?.slug ? "clickable-menu-card" : ""
        }`}
        onClick={() => cardData?.slug && handleClick(true)}
      >
        <div className="menu-image-wrapper">
          <img
            src={cardData?.MenuImage?.asset?.url}
            loading="lazy"
            className="solution-image"
            alt={`solution-${index}`}
          />
          <h3 className="solution-title">{cardData?.MenuTitle}</h3>
        </div>
        <div className="solution-description-section">
          <p className="solution-description">
            <span>{cardData?.MenuDescriptionPreview}</span>
          </p>
          {cardData?.slug && (
            <Link
              className="learn-more-cta"
              to={`${
                cardData?.cardType
                  ? "/" + cardData.cardType + "/" + cardData.slug.current
                  : "/" + cardData.slug.current
              }`}
              onClick={() => handleClick(true)}
            >
              Explore
            </Link>
          )}
          {/* <p className="useCase-details">{cardData?.useCase}</p> */}
        </div>
        {/* {isMobile ? <div className="learn-more-cta-container">
          <p className="learn-more-cta" onClick={() => handleClick(true)}>Learn more</p>
          {cardData?.CTARedirect && (
            <div className="button_container">
              <button
                className="button-cl connectBtn"
                onClick={() => onContactUsBtnClick("Book_Demo_cta")}
              >
                Book Demo
              </button>
            </div>
          )}
        </div> : */}
        {/* <p className="learn-more-cta" onClick={() => handleClick(true)}>Learn more</p> */}
        {/* } */}
        {/* <p className="useCase-details">{cardData?.useCase}</p> */}
        {/* {cardData?.CTARedirect && !isMobile && (
          <div className="button_container">
            <button
              className="button-cl connectBtn"
              onClick={() => onContactUsBtnClick("Book_Demo_cta")}
            >
              Book Demo
            </button>
          </div>
        )} */}
      </div>
      {/* {readMore && (
        <div
          className={`menu-card-details popup-menu-card ${
            readMore ? "adjust-height" : ""
          }`}
        >
          <img
            src={closeIcon}
            alt="close icon"
            className="popup-close-icon"
            onClick={() => handleClick(false)}
          />
          <div className="image-wrapper">
            <img
              src={cardData?.MenuImage?.asset?.url}
              loading="lazy"
              className="solution-image"
              alt={`solution-${index}`}
            />
            <p className="solution-title">{cardData?.MenuTitle}</p>
          </div>
          <div className="solution-description-section">
            <p className="solution-description solution-description-title">
              <span>{cardData.MenuDescriptionPreview}</span>
            </p>
            <p
              className="solution-description"
              dangerouslySetInnerHTML={{
                __html: purify?.sanitize(
                  handleSpanTag(cardData?.MenuDescription)
                ),
              }}
            ></p>
            <p className="useCase-details">{cardData.useCase}</p>
          </div>
        </div>
      )} */}

      <Dialog
        visible={readMore}
        onHide={() => handleClick(false)}
        // closeIcon={<img src={closeIcon} alt="close icon" />}
        position={
          typeof window !== "undefined"
            ? window.innerWidth > 768
              ? "center"
              : "bottom"
            : "center"
        }
        showHeader={false}
        draggable={false}
        dismissableMask={true}
      >
        <Button
          icon="pi pi-times"
          style={{
            position: "absolute",
            top: "-45px",
            right: "0px",
            backgroundColor: "rgb(226, 226, 226)",
            color: "#2B2A2A",
            borderRadius: "30px",
            padding: "8px",
            border: "0px",
            outline: "0px",
            fontSize: "18px",
          }}
          onClick={() => handleClick(false)}
          rounded
        />
        <div className="image-wrapper">
          <img
            src={cardData?.MenuImage?.asset?.url}
            loading="lazy"
            className="solution-image"
            alt={`solution-${index}`}
          />
          <p className="solution-title">{cardData?.MenuTitle}</p>
        </div>
        <div className="solution-description-section">
          <p className="solution-description solution-description-title">
            <span>{cardData?.MenuDescriptionPreview}</span>
          </p>
          <p
            className="solution-description"
            dangerouslySetInnerHTML={{
              __html: purify?.sanitize(
                handleSpanTag(cardData?.MenuDescription)
              ),
            }}
          ></p>
          <p className="useCase-details">{cardData?.useCase}</p>
        </div>
      </Dialog>
    </div>
  )
}

export default MenuCard
